module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/6413e16217a63f64ee49da2fac348668.png";